import { useState, useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Sub-components
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import ProblemSection from './components/ProblemSection';
import HowItWorksSection from './components/HowItWorksSection';
import BenefitsSection from './components/BenefitsSection';
import CategoriesSection from './components/CategoriesSection';
import NetworkSection from './components/NetworkSection';
import FaqSection from './components/FaqSection';
import FinalCtaSection from './components/FinalCtaSection';

const AuthLayout = () => {
  const navigate = useNavigate();
  const [isScrolled, setIsScrolled] = useState(false);
  const [problemFilter, setProblemFilter] = useState('both');
  const [activeBenefitIdx, setActiveBenefitIdx] = useState(0);
  const [openFaqIdx, setOpenFaqIdx] = useState(0);
  const [activeNavSection, setActiveNavSection] = useState('');
  const [isSwitchingBenefit, setIsSwitchingBenefit] = useState(false);
  const [hoveredBladeIdx, setHoveredBladeIdx] = useState(null);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    // Redirect authenticated users away from auth pages (/, /login, /signup)
    const restaurantToken = localStorage.getItem("token_partner_restaurant");
    const shopToken = localStorage.getItem("token_partner_shop");
    const activityToken = localStorage.getItem("token_partner_activities");

    if (restaurantToken) {
      navigate("/restaurant", { replace: true });
    } else if (shopToken) {
      navigate("/shop", { replace: true });
    } else if (activityToken) {
      navigate("/activity", { replace: true });
    }
  }, [navigate]);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);

      const sections = ['problem', 'how', 'benefits', 'categories', 'faq'];
      let current = '';
      sections.forEach(secId => {
        const el = document.getElementById(secId);
        if (el) {
          const top = el.offsetTop - 120;
          const height = el.offsetHeight;
          if (window.scrollY >= top && window.scrollY < top + height) {
            current = secId;
          }
        }
      });
      setActiveNavSection(current);
    };

    const handleResize = () => setWindowWidth(window.innerWidth);

    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const handleSwitchBenefit = (idx) => {
    if (isSwitchingBenefit) return;
    setIsSwitchingBenefit(true);
    setActiveBenefitIdx(idx);
    setTimeout(() => setIsSwitchingBenefit(false), 180);
  };

  const scrollToSection = (e, id) => {
    if (e) e.preventDefault();
    setIsMobileMenuOpen(false);
    const element = document.getElementById(id);
    if (element) {
      const topOffset = element.getBoundingClientRect().top + window.pageYOffset - 80;
      window.scrollTo({
        top: topOffset,
        behavior: 'smooth'
      });
    }
  };

  const isDesktop = windowWidth >= 768;

  return (
    <div style={{ background: '#FAFAF8', color: '#0F172A', minHeight: '100vh', overflowX: 'hidden' }}>
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar />

      <Navbar 
        isScrolled={isScrolled}
        activeNavSection={activeNavSection}
        isMobileMenuOpen={isMobileMenuOpen}
        setIsMobileMenuOpen={setIsMobileMenuOpen}
        scrollToSection={scrollToSection}
      />

      <HeroSection 
        isDesktop={isDesktop}
        scrollToSection={scrollToSection}
      />

      <ProblemSection />

      <HowItWorksSection />

      <BenefitsSection />

      <CategoriesSection />

      <NetworkSection />

      <FaqSection 
        openFaqIdx={openFaqIdx}
        setOpenFaqIdx={setOpenFaqIdx}
      />

      <FinalCtaSection />
    </div>
  );
};

export default AuthLayout;
